
import React from "react";
import Contact1 from "./Contact1";
import NavbarTailwind from "../../components/Navbar/NavbarTailWind";
import Footer from "../../components/Footer/Footer";






export default function ContactMain(){



    return(
         <>
         <NavbarTailwind/>
        <div className="flex flex-col w-full justify-center ites-center mt-20">
         <Contact1/>
        </div>
        <Footer/>
        </>
    )
}